// The rich composer sub-block: TipTap editor with skill/artifact mention
// chips, serializer, and the composer frame. These files are the single
// source of truth for the npm package (`@bg-bgi/magnus-ui`), the
// shadcn registry, and (via re-export shims) the private `@magnus/react`.
// Edit here; never fork.

export {
  type ActiveArtifactSuggestion,
  type ArtifactMentionAttrs,
  type ArtifactMentionOptions,
  toArtifactMentionAttrs,
  useArtifactMention,
} from "./artifact-mention";
export {
  AttachmentsScroll,
  AttachmentTile,
  type AttachmentTileProps,
  type AttachmentValidation,
  attachmentAcceptsFile,
  attachmentCapacity,
  attachmentIcon,
  type ComposerProcessingUpdate,
  type ComposerUploadsSource,
  MessageAttachmentsScroll,
  SentAttachmentTile,
  type SentAttachmentTileProps,
  toAttachmentFilePart,
  validateAttachment,
} from "./attachments";
export {
  ComposerLiveCallButton,
  type ComposerLiveCallPhase,
  type ComposerLiveCallSource,
  showsLiveCallButton,
} from "./live-call-button";
export {
  AUTO_MODEL_SELECTION,
  type ComposerModelsSource,
  ModelSelector,
} from "./model-selector";
export {
  ARTIFACT_REF_RE,
  type ArtifactPickerItem,
  type ArtifactReferencePart,
  SKILL_REF_RE,
  type SkillPickerItem,
  type SkillReferencePart,
} from "./refs";
export {
  type ComposerUploadedFile,
  type FollowUpQueueResult,
  RichComposer,
  type RichComposerHandle,
  type RichComposerProps,
  type RichComposerRightClusterContext,
} from "./rich-composer";
export {
  type EditorFilePart,
  type EditorNodeJSON,
  type EditorPart,
  type EditorTextPart,
  partsToPromptString,
  promptToTiptapDoc,
  serializeDocToParts,
  type TiptapDoc,
} from "./serialize";
export {
  type ActiveSuggestion,
  isSuggestionActive,
  type MentionCommand,
  type MentionManageLink,
  matchCommands,
  SkillChipHoverProvider,
  type SkillMentionAttrs,
  type SkillMentionOptions,
  toMentionAttrs,
  useSkillMention,
} from "./skill-mention";
export {
  PASTE_AS_FILE_THRESHOLD,
  serializeEditorToParts,
  TipTapSkillInput,
  type TipTapSkillInputHandle,
} from "./tiptap-input";
export {
  type AttachmentStatus,
  type ComposerAttachment,
  type UseAttachmentsResult,
  useAttachments,
} from "./use-attachments";
export {
  ComposerDictationButton,
  type ComposerDictationSource,
  type ComposerDictationState,
  useDictationTranscriptInsert,
} from "./voice";
